import React from 'react';
import {BadgeTranslations, SpecialSizesBadges} from '../types';
import {Badge, BadgeProps} from './Badge';

export const SpecialSizesBadge: React.FC<
  BadgeProps & {
    specialSizes: SpecialSizesBadges;
    translations: BadgeTranslations;
  }
> = ({specialSizes, translations, ...badgeProps}) => {
  const activeSpecialSize = Object.entries(specialSizes).find(
    ([_, value]) => value,
  )![0] as keyof SpecialSizesBadges; // non-null assertion with `!` since its already validated in BadgeList that at least on of the specialSizes is active

  const text = {
    isForMom: translations.specialSizes.mom,
    isForPetite: translations.specialSizes.petite,
    isForTall: translations.specialSizes.tall,
    isPlusSizeMale: translations.specialSizes.plusSizeMale,
    isPlusSizeFemale: translations.specialSizes.plusSizeFemale,
  }[activeSpecialSize];

  return <Badge {...badgeProps} text={text} />;
};
